__turbopack_context__.v({
  "option_icon": "search-place-option-new-module-scss-module__Sriv4W__option_icon",
  "option_link": "search-place-option-new-module-scss-module__Sriv4W__option_link",
});
